module.exports = __webpack_public_path__ + "img/emoji_33.346ed14c.png";